<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative text-center">
      <p class="text-center font-semibold">{{ message }}</p>

      <button class="link mt-4 mx-auto w-full" @click.prevent="close">
        Aceptar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accept Modal",

  props: {
    message: String,
  },

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>